import React, { useEffect } from 'react';
import '../assets/panier.css';
import { Link } from 'react-router-dom';
import Navbar from './Navbar';

function Panier() {
  const prods = [{
    id: 1,
    nom: "Gelato HHCP 7%",
    prix: "13,90€ - 11,00€/g",
    note: "4,5",
    avis: "8",
    image: "/images/produits/gelato.png"
  },{
    id: 2,
    nom: "Pack Shoptapromotion - CBD, CBG, HHC, HHCP...",
    prix: "7,00€ - 6,00€/g ",
    note: "4,5",
    avis: "8",
    image: "/images/produits/pack.png"
  },{
    id: 3,
    nom: "Fruity Punch HHC 50% + CBD 10%",
    prix: "13,90€ - 11,00€/g",
    note: "4,5",
    avis: "8",
    image: "/images/produits/fruity.png"
  }
];

  useEffect(()=>{
    let header = document.querySelector('#menu');
    let burger = document.querySelector('.navbar-toggler');
    header?.classList.add('bg-navbar');

    if (window.screen.width < 985) {
      header?.classList.remove('scrolled');
      header?.classList.remove('bg-navbar');
      header?.classList.add('menuPanierOuProduit');
      burger?.classList.add("menuburger");
    }
  }, [])
  return (
    <div>
        <Navbar />
        <div className='container page-panier mt-5'>
          <div className='panier-group mb-4 pb-5'>
            <div className='item-img'>
              <img src={window.location.origin +"/images/categories/run.png"} alt="" />
            </div>
            <div className='item-detail'>
              <div>
                <h1 className='detail-title'>E-Liquide HHC</h1>
                <p className='detail-text'>Menthe 20% HHC</p>
                <div className='mb-3'>
                  <input type='number' className='text-dark' id='input-panier' min="1"/> <a type="button" className='ms-3 delete' id='delete'>Supprimer</a>
                </div>
                <p className='detail-point'>59 points de fidélité</p>
              </div>
              <div>
                <h1 className='detail-price'>59,90£</h1>
              </div>
            </div>
          </div>
          <div className='like-group mt-5'>
            <h1 className='like-title mt-5'>VOUS AIMEREZ AUSSI</h1>
            <div className="cat-body container mt-5">
              {
                prods.map(prod => <div className="cat-item" key={prod.id}>
                  <Link className='item-title' to={{
                     pathname: "/produit/"+prod.id
                      }}><img id='img-prod' src={prod.image} alt="" /></Link>
                      <h3><Link className='item-title' to={{
                            pathname: "/produit/"+prod.id
                      }}>{prod.nom}</Link></h3>
                      <p className='item-price'>{prod.prix} </p>
                      <p className='item-note'>
                      <span> {prod.note}</span> <span><img src={window.location.origin +"/images/start.png"} alt="" /></span><span className='avis'> {prod.avis} avis</span>
                    </p>
                </div>)
              }
            
        </div>
          </div>
        </div>
        
    </div>
  )
}

export default Panier